import CrossHair from '@common-components/graphs/cross-hair-graph/CrossHair'
import React from 'react'
import {  useParams, useSearchParams } from 'react-router-dom';

export default function ReceivedGraph() {
    const params = useParams()
    const [searchParams] = useSearchParams();
    const batchId = searchParams.get("batchID");
    const startDate = searchParams.get("startDate");
    const endDate = searchParams.get("endDate");
    const filter = searchParams.get("filter"); 
    return (
        <div className='mt-10'>
            <CrossHair type="full" supplierID={params.id} batchId = {batchId} sDate = {startDate} eDate = {endDate} filter = {filter} />

        </div>
    )
}
